module.exports = __webpack_public_path__ + "static/media/blinds-raised.266d5d94.svg";